import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export function Layout() {
  return (
    <div className="min-h-screen bg-paper">
      <Header />
      <main className="px-4 py-8">
        <Outlet />
      </main>
    </div>
  );
}
